module.exports = __webpack_public_path__ + "static/img/surfaceBanner.65ca294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surfaceBanner.png
// module id = LQ8J
// module chunks = 2